import { useMemo } from 'react';
import cls from 'classnames';
import { RightOutline } from 'antd-mobile-icons';
import styles from './index.module.scss';
export default (props: Record<string, any>) => {
  const { links } = props;
  const menus = useMemo(() => {
    const subNodes: Array<any> = [];
    const filLinks = (linkArra: Array<Record<string, any>>, level = 0) => {
      linkArra.forEach((item: Record<string, any>, index: number) => {
        if (level == 0) {
          subNodes.push(
            <div className={index === 0 ? styles['first-level'] : cls(styles['first-level'], styles['line'])}>
              {item.urlH5 ? (
                <a className={cls(styles['first-title'], 'flex')} href={item.urlH5} target="_blank" rel="noreferrer">
                  <img src={item.icon} className={styles['icon']} />
                  <span className={styles['inner-title']}> {item.nameH5 || item.name}</span>
                </a>
              ) : (
                <span className={cls(styles['first-title'], 'flex')}>
                  <img src={item.icon} className={styles['icon']} />
                  <span className={styles['inner-title']}> {item.nameH5 || item.name}</span>
                </span>
              )}
            </div>
          );
          if (item.children?.length) {
            filLinks(item.children, level + 1);
          }
        } else if (level == 1) {
          subNodes.push(
            <div className={cls(styles['second-level'], 'flex')}>
              <>
                <a className={cls(styles['second-title'], 'flex1')} href={item.urlH5} target="_blank" rel="noreferrer">
                  {item.nameH5 || item.name}
                </a>
                <RightOutline className={styles['right-icon']} />
              </>
            </div>
          );
        } else {
          subNodes.push(
            <div className={styles['three-level']}>
              <a className={styles['three-title']} href={item.urlH5} target="_blank" rel="noreferrer">
                {item.nameH5 || item.name}
              </a>
            </div>
          );
        }
      });
    };
    filLinks(links || [], 0);
    return subNodes;
  }, [links]);
  return <div className={styles['panel-list']}>{menus}</div>;
};
